import './DescriptionList.scss';

import React from 'react';

interface IProps {
  items: { title: string; value: string }[];
}

function DescriptionList({ items }: IProps) {
  return (
    <dl className="modDescriptionList">
      {items.map((item, i) => (
        <div key={i} className="modDescriptionList__item">
          <dt className="modDescriptionList__item__title">{item.title}</dt>
          <dd className="modDescriptionList__item__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default DescriptionList;
